import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses a per-line effective maximum.
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  getEffectiveMax() {
    const { max, cartQuantity, value } = this.getCurrentValues();
    if (max === null) return null;

    const otherCartQuantity = Math.max(cartQuantity - value, 0);
    return Math.max(max - otherCartQuantity, 0);
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();

    minusButton.disabled = value <= min;
    plusButton.disabled = false;

    this.updateLimitState();
  }

  /**
   * On cart selectors we should not silently clamp the current server-rendered value,
   * because it can make other rows appear to "roll back". We only refresh states.
   */
  updateCartQuantity() {
    this.clearLimitFeedback();
    this.updateButtonStates();
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}